module.exports = __webpack_public_path__ + "img/Driver.a9fcb9c5.png";